import "./404.58cfd041.js";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea80d"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea80d"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5QDZi", function(module, exports) {

$parcel$export(module.exports, "getEnv", function () { return $4420d3cf14c8511c$export$4bd44a2aa29d3d6e; });
$parcel$export(module.exports, "genRandStr", function () { return $4420d3cf14c8511c$export$9523f26048d69498; });
// UTILITAIRES EN VRAC
function $4420d3cf14c8511c$export$4bd44a2aa29d3d6e() {
    switch(location.hostname){
        case 'vitroto.fr':
        case 'www.vitroto.fr':
        case 'vps-ee7fed3b.vps.ovh.net':
            return 'prod';
        case 'dev.vitroto.fr':
        case 'test.vitroto.fr':
        case 'vps235287.ovh.net':
            return 'dev';
        default:
            throw 'utils.getEnv(): check hostname: ' + location.hostname;
    }
}
function $4420d3cf14c8511c$export$9523f26048d69498(len) {
    // Timestamp's based for ordering
    len = len || 40;
    var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    var text = '';
    for(var i = 0; i < len; i++)text += chars.charAt(Math.floor(Math.random() * chars.length));
    // Ou:
    //text = Math.random().toString(36).substr(2,11);	    // 10 ou 11 chars
    return text;
}
function $4420d3cf14c8511c$export$1c66a7c513d1624(str) {
    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br>$2');
}
function $4420d3cf14c8511c$export$61fc7d43ac8f84b0(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}
function $4420d3cf14c8511c$export$529f52b70a3feab9(array, key, sens, lowercase) {
    sens = sens || 'asc';
    lowercase = lowercase || false;
    var length = array.length - 1, done, i, j;
    for(i = 0; i < length; i++){
        done = true;
        for(j = 0; j < length; j++){
            var item1 = array[j], item2 = array[j + 1];
            var value1 = item1[key], value2 = item2[key];
            if (lowercase) {
                value1 = value1.toLowerCase();
                value2 = value2.toLowerCase();
            }
            if (sens === 'asc' && value1 > value2 || sens === 'desc' && value1 < value2) {
                array[j] = item2;
                array[j + 1] = item1;
                done = false;
            }
        }
        if (done) break;
    }
}
function $4420d3cf14c8511c$export$4cf11838cdc2a8a8(html) {
    var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#x27;',
        '/': '&#x2F;'
    };
    var htmlEscaper = /[&<>"'\/]/g;
    return ('' + html).replace(htmlEscaper, function(match) {
        return htmlEscapes[match];
    });
}
function $4420d3cf14c8511c$export$54c55c906b2ca7e5(el) {
    if (typeof el.selectionStart == "number") el.selectionStart = el.selectionEnd = el.value.length;
    else if (typeof el.createTextRange != "undefined") {
        el.focus();
        var range = el.createTextRange();
        range.collapse(false);
        range.select();
    }
}
function $4420d3cf14c8511c$export$a6cdc56e425d0d0a(o) {
    return [
        'object',
        'function'
    ].includes(typeof o) && o !== null;
}

});

parcelRequire("a0S24");

var $k8PoE = parcelRequire("k8PoE");

var $kNNyJ = parcelRequire("kNNyJ");

var $5QDZi = parcelRequire("5QDZi");
// Debug
if ((0, $5QDZi.getEnv)() === 'dev') {
    // Peu importe si on divulgue ces informations en prod, ce ne sont pas de vrais logins
    document.getElementById('login-right').insertAdjacentHTML('beforeend', `
	<div class="mt-3" style="cursor: pointer;">
	    <div class="tmp-login" data-email="admin@vitroto.fr" data-pwd="FNvNIGG3/kZSS9lVld/l">Compte admin</div>
	    <div class="tmp-login" data-email="michael.robertson@free.fr" data-pwd="FNvNIGG3/kZSS9lVld/l">Compte responsable</div>
	    <div class="tmp-login" data-email="micriprob@gmail.com" data-pwd="FNvNIGG3/kZSS9lVld/l">Compte agence</div>
	</div>
    `);
    document.querySelectorAll('.tmp-login')?.forEach((el)=>{
        el.addEventListener('click', (e)=>{
            document.getElementById('email').value = el.dataset.email;
            document.getElementById('pwd').value = el.dataset.pwd;
            document.querySelector('#main-form button[type="submit"]').click();
        });
    });
}
// LOGIN
document.getElementById('main-form').addEventListener('submit', async function(e) {
    e.preventDefault();
    const formData = new FormData(this);
    formData.append('a', 'login');
    await (0, $k8PoE.post)(formData, {
        auth: false,
        err_msg: {
            '': "Vos informations n'ont pas \xe9t\xe9 reconnues"
        }
    });
    //this.remove();
    //history.replaceState({success: true}, 'title', '/success.html')
    window.location.reload(); // Attente validation par admin
});
// MOT DE PASSE OUBLIÉ
document.getElementById('forgot-pwd').addEventListener('click', function(e) {
    const popup = $b7d183ff37c9ffd7$var$getPopup();
    document.getElementById('fp-email').value = document.getElementById('email').value;
    document.getElementById('fp-pwd').value = '';
    document.getElementById('form-forgot-pwd').classList.remove('was-validated');
    popup.show();
});
// HELPERS
function $b7d183ff37c9ffd7$var$getPopup() {
    if ($b7d183ff37c9ffd7$var$getPopup.popup === null) {
        const body = `
	<form id="form-forgot-pwd" class="needs-validation" novalidate>
	    <div class="mb-3">
		<label for="fp-email">Identifiant</label>
		<input type="email" name="email" id="fp-email" class="form-control" autocomplete="username" required>
		<div class="invalid-feedback">Veuillez indiquer votre email</div>
	    </div>
	    <div class="mb-3">
		<label for="fp-pwd">Nouveau mot de passe (*)</label>
		<input type="password" name="new_pwd" id="fp-pwd" class="form-control" autocomplete="new-password" minlength="6" required
		pattern="(?=.*[a-z])(?=.*[A-Z]).*">
		<div class="invalid-feedback">Veuillez indiquer votre mot de passe (minimum 6 caract\xe8res dont minuscule - majuscule)</div>
	    </div>
	    <small>(*) Ce nouveau mot de passe sera activ\xe9 lorsque vous aurez cliqu\xe9 dans l'email que vous allez recevoir.<br><br>
	    Cette email est valable 24h.<small>
	</form>`;
        const popup = $b7d183ff37c9ffd7$var$getPopup.popup = (0, $kNNyJ.Popup).get('popup-forgot-pwd', {
            btn_x: true,
            backdrop: 'static',
            html_header: '<h1 class="h2">Mot de passe oubli\xe9</h1>',
            html_body: body,
            html_footer: '<button type="submit" form="form-forgot-pwd" class="btn btn-primary">Soumettre</button>'
        });
        popup.setEvents([
            {
                selector: '#form-forgot-pwd',
                type: 'submit',
                listener: async function(e) {
                    e.preventDefault();
                    const form_data = new FormData(this);
                    form_data.append('a', 'forgot_pwd');
                    await (0, $k8PoE.post)(form_data, {
                        auth: false,
                        msg_success: "Veuillez cliquer dans le lien qui vient de vous \xeatre envoy\xe9 afin de valider votre nouveau mot de passe"
                    });
                    popup.hide();
                }
            }
        ]);
    }
    return $b7d183ff37c9ffd7$var$getPopup.popup;
}
$b7d183ff37c9ffd7$var$getPopup.popup = null;


//# sourceMappingURL=connexion.1529a3a2.js.map
